module.exports = __webpack_public_path__ + "media/images/project/orange-plus-2a0688af74f9113fd3829dbcffc4bc7f.svg";